module.exports = __webpack_public_path__ + "assets/img/ddm_all.c7f3cce9.jpg";